module.exports = __webpack_public_path__ + "img/ticket2.02691f83.png";